import { Competition, Location, Locations } from '../types'

const LOCATIONS: Locations = {
  mediterranean: {
    name: 'Mediterranean',
    key: 'mediterranean',
    location: 'Various Spots',
    surfSpots: ['Marina di Pietrasanta', 'Capo Mannu', 'Varazze'],
    surfSessionCost: 0,
    surfConsistency: {
      zero: 0.053,
      less_than_10: 0.151,
      from_11_to_30: 0.278,
      from_31_to_60: 0.301,
      from_61_to_120: 0.171,
      from_121_to_180: 0.046,
      from_181_to_270: 0.0,
      from_271_to_365: 0.0
    },
    waveHeight: {
      knee_high: 0.412,
      waist_high: 0.351,
      shoulder_high: 0.137,
      head_high: 0.07,
      overhead: 0.03,
      one_and_half_overhead: 0.0,
      two_overhead: 0.0,
      three_overhead: 0.0,
      big_wave: 0.0
    },
    waveType: {
      crumbling: 0.482,
      easy: 0.308,
      punchy: 0.15,
      hollow: 0.06,
      slab: 0.0
    },
    breakType: {
      beach_break_short: 1.0,
      point_break_medium: 0.0,
      point_break_long: 0.0,
      reef_break_short: 0.0,
      reef_break_medium: 0.0,
      reef_break_long: 0.0
    },
    waveSpeed: {
      slow: 0.792,
      fast: 0.208,
      closeouts: 0.0
    },
    waveTime: {
      less_than_1: 0.307,
      one_to_two: 0.418,
      three_to_five: 0.275,
      six_to_ten: 0.0,
      eleven_to_twenty: 0.0,
      twenty_one_to_forty: 0.0,
      more_than_forty: 0.0
    },
    crowd: {
      uncrowded: 0.52,
      small_crowd: 0.48,
      big_crowd: 0,
      packed: 0.0
    },
    crowdSkill: {
      beginners: 0.692,
      intermediates: 0.278,
      advanced: 0.0,
      pros: 0.0
    },
    competitions: [
      {
        key: 'varazze_open',
        name: 'Varazze Open',
        prize: 1600,
        entryFee: 50,
        maxCompetitors: 32,
        unlockRules: [],
        avgCompetitorRating: 3,
        restartIntervalDays: 7
      }
    ]
  },
  france: {
    name: 'France',
    key: 'france',
    location: 'Southwest France',
    surfSpots: ['Hossegor', 'Biarritz', 'La Gravière'],
    surfSessionCost: 20,
    surfConsistency: {
      zero: 0.03,
      less_than_10: 0.08,
      from_11_to_30: 0.15,
      from_31_to_60: 0.2,
      from_61_to_120: 0.25,
      from_121_to_180: 0.2,
      from_181_to_270: 0.09,
      from_271_to_365: 0.0
    },
    waveHeight: {
      knee_high: 0.1,
      waist_high: 0.3,
      shoulder_high: 0.34,
      head_high: 0.2,
      overhead: 0.04,
      one_and_half_overhead: 0.02,
      two_overhead: 0.0,
      three_overhead: 0.0,
      big_wave: 0.0
    },
    waveType: {
      crumbling: 0.35,
      easy: 0.3,
      punchy: 0.25,
      hollow: 0.1,
      slab: 0.0
    },
    breakType: {
      beach_break_short: 1.0,
      point_break_medium: 0.0,
      point_break_long: 0.0,
      reef_break_short: 0.0,
      reef_break_medium: 0.0,
      reef_break_long: 0.0
    },
    waveSpeed: {
      slow: 0.65,
      fast: 0.3,
      closeouts: 0.05
    },
    waveTime: {
      less_than_1: 0.2,
      one_to_two: 0.3,
      three_to_five: 0.35,
      six_to_ten: 0.15,
      eleven_to_twenty: 0.0,
      twenty_one_to_forty: 0.0,
      more_than_forty: 0.0
    },
    crowd: {
      uncrowded: 0.35,
      small_crowd: 0.45,
      big_crowd: 0.2,
      packed: 0.0
    },
    crowdSkill: {
      beginners: 0.55,
      intermediates: 0.35,
      advanced: 0.1,
      pros: 0.0
    },
    competitions: [
      {
        key: 'hossegor_open',
        name: 'Hossegor Open',
        prize: 3000,
        entryFee: 100,
        maxCompetitors: 48,
        unlockRules: [],
        avgCompetitorRating: 4,
        restartIntervalDays: 14
      },
      {
        key: 'wsa_qualifier_hossegor',
        name: 'WSA Qualifier - Hossegor',
        prize: 10000,
        entryFee: 250,
        maxCompetitors: 64,
        unlockRules: [{ category: 'contest', key: 'hossegor_open', value: 'quarterfinals' }],
        avgCompetitorRating: 5,
        restartIntervalDays: 30
      },
      {
        key: 'wsa_championship_la_graviere',
        name: 'WSA Championship - La Gravière',
        prize: 25000,
        entryFee: 500,
        maxCompetitors: 32,
        unlockRules: [{ category: 'contest', key: 'wsa_qualifier_hossegor', value: 'semifinals' }],
        avgCompetitorRating: 6,
        restartIntervalDays: 60
      }
    ]
  },
  portugal: {
    name: 'Portugal',
    key: 'portugal',
    location: 'Portugal Coast',
    surfSpots: ['Peniche', 'Nazaré', 'Ericeira'],
    surfSessionCost: 15,
    surfConsistency: {
      zero: 0.0,
      less_than_10: 0.0,
      from_11_to_30: 0.0,
      from_31_to_60: 0.0,
      from_61_to_120: 0.15,
      from_121_to_180: 0.25,
      from_181_to_270: 0.35,
      from_271_to_365: 0.25
    },
    waveHeight: {
      knee_high: 0.05,
      waist_high: 0.15,
      shoulder_high: 0.25,
      head_high: 0.3,
      overhead: 0.15,
      one_and_half_overhead: 0.07,
      two_overhead: 0.02,
      three_overhead: 0.01,
      big_wave: 0.0
    },
    waveType: {
      crumbling: 0.1,
      easy: 0.2,
      punchy: 0.3,
      hollow: 0.3,
      slab: 0.1
    },
    breakType: {
      beach_break_short: 0.4,
      point_break_medium: 0.3,
      point_break_long: 0.1,
      reef_break_short: 0.1,
      reef_break_medium: 0.1,
      reef_break_long: 0.0
    },
    waveSpeed: {
      slow: 0.3,
      fast: 0.6,
      closeouts: 0.1
    },
    waveTime: {
      less_than_1: 0.05,
      one_to_two: 0.15,
      three_to_five: 0.3,
      six_to_ten: 0.3,
      eleven_to_twenty: 0.15,
      twenty_one_to_forty: 0.05,
      more_than_forty: 0.0
    },
    crowd: {
      uncrowded: 0.1,
      small_crowd: 0.3,
      big_crowd: 0.4,
      packed: 0.2
    },
    crowdSkill: {
      beginners: 0.2,
      intermediates: 0.4,
      advanced: 0.3,
      pros: 0.1
    },
    competitions: [
      {
        key: 'ericeira_open',
        name: 'Ericeira Open',
        prize: 5000,
        entryFee: 150,
        maxCompetitors: 48,
        unlockRules: [],
        avgCompetitorRating: 5,
        restartIntervalDays: 14
      },
      {
        key: 'wsa_qualifier_ericeira',
        name: 'WSA Qualifier - Ericeira',
        prize: 12000,
        entryFee: 300,
        maxCompetitors: 64,
        unlockRules: [{ category: 'contest', key: 'ericeira_open', value: 'quarterfinals' }],
        avgCompetitorRating: 6,
        restartIntervalDays: 30
      },
      {
        key: 'wsa_championship_peniche',
        name: 'WSA Championship - Peniche',
        prize: 30000,
        entryFee: 600,
        maxCompetitors: 32,
        unlockRules: [{ category: 'contest', key: 'wsa_qualifier_ericeira', value: 'semifinals' }],
        avgCompetitorRating: 7,
        restartIntervalDays: 60
      }
    ]
  },
  south_africa: {
    name: 'South Africa',
    key: 'south_africa',
    location: 'South Africa Coast',
    surfSpots: ['Jeffreys Bay', 'Cape St. Francis', 'Durban'],
    surfSessionCost: 20,
    surfConsistency: {
      zero: 0.0,
      less_than_10: 0.0,
      from_11_to_30: 0.0,
      from_31_to_60: 0.05,
      from_61_to_120: 0.15,
      from_121_to_180: 0.3,
      from_181_to_270: 0.35,
      from_271_to_365: 0.15
    },
    waveHeight: {
      knee_high: 0.05,
      waist_high: 0.1,
      shoulder_high: 0.2,
      head_high: 0.3,
      overhead: 0.2,
      one_and_half_overhead: 0.1,
      two_overhead: 0.04,
      three_overhead: 0.01,
      big_wave: 0.0
    },
    waveType: {
      crumbling: 0.1,
      easy: 0.2,
      punchy: 0.3,
      hollow: 0.3,
      slab: 0.1
    },
    breakType: {
      beach_break_short: 0.2,
      point_break_medium: 0.3,
      point_break_long: 0.3,
      reef_break_short: 0.1,
      reef_break_medium: 0.1,
      reef_break_long: 0.0
    },
    waveSpeed: {
      slow: 0.2,
      fast: 0.7,
      closeouts: 0.1
    },
    waveTime: {
      less_than_1: 0.05,
      one_to_two: 0.1,
      three_to_five: 0.2,
      six_to_ten: 0.3,
      eleven_to_twenty: 0.25,
      twenty_one_to_forty: 0.1,
      more_than_forty: 0.0
    },
    crowd: {
      uncrowded: 0.1,
      small_crowd: 0.3,
      big_crowd: 0.4,
      packed: 0.2
    },
    crowdSkill: {
      beginners: 0.1,
      intermediates: 0.3,
      advanced: 0.4,
      pros: 0.2
    },
    competitions: [
      {
        key: 'durban_open',
        name: 'Durban Open',
        prize: 7000,
        entryFee: 200,
        maxCompetitors: 48,
        unlockRules: [],
        avgCompetitorRating: 6,
        restartIntervalDays: 14
      },
      {
        key: 'wsa_qualifier_cape_st_francis',
        name: 'WSA Qualifier - Cape St. Francis',
        prize: 15000,
        entryFee: 350,
        maxCompetitors: 64,
        unlockRules: [{ category: 'contest', key: 'durban_open', value: 'quarterfinals' }],
        avgCompetitorRating: 7,
        restartIntervalDays: 30
      },
      {
        key: 'wsa_championship_jeffreys_bay',
        name: 'WSA Championship - Jeffreys Bay',
        prize: 35000,
        entryFee: 700,
        maxCompetitors: 32,
        unlockRules: [{ category: 'contest', key: 'wsa_qualifier_cape_st_francis', value: 'semifinals' }],
        avgCompetitorRating: 8,
        restartIntervalDays: 60
      }
    ]
  },
  california: {
    name: 'California',
    key: 'california',
    location: 'California, USA',
    surfSpots: ['Huntington Beach', 'Malibu', 'Trestles'],
    surfSessionCost: 50,
    surfConsistency: {
      zero: 0.0,
      less_than_10: 0.0,
      from_11_to_30: 0.0,
      from_31_to_60: 0.0,
      from_61_to_120: 0.174,
      from_121_to_180: 0.328,
      from_181_to_270: 0.273,
      from_271_to_365: 0.525
    },
    waveHeight: {
      knee_high: 0.0,
      waist_high: 0.213,
      shoulder_high: 0.287,
      head_high: 0.322,
      overhead: 0.178,
      one_and_half_overhead: 0.0,
      two_overhead: 0.0,
      three_overhead: 0.0,
      big_wave: 0.0
    },
    waveType: {
      crumbling: 0.0,
      easy: 0.479,
      punchy: 0.308,
      hollow: 0.213,
      slab: 0.0
    },
    breakType: {
      beach_break_short: 0.0,
      point_break_medium: 0.494,
      point_break_long: 0.0,
      reef_break_short: 0.506,
      reef_break_medium: 0.0,
      reef_break_long: 0.0
    },
    waveSpeed: {
      slow: 0.614,
      fast: 0.386,
      closeouts: 0.0
    },
    waveTime: {
      less_than_1: 0.0,
      one_to_two: 0.0,
      three_to_five: 0.326,
      six_to_ten: 0.307,
      eleven_to_twenty: 0.367,
      twenty_one_to_forty: 0.0,
      more_than_forty: 0.0
    },
    crowd: {
      uncrowded: 0.0,
      small_crowd: 0.0,
      big_crowd: 0.236,
      packed: 0.764
    },
    crowdSkill: {
      beginners: 0.0,
      intermediates: 0.512,
      advanced: 0.304,
      pros: 0.184
    },
    competitions: [
      {
        key: 'huntington_beach_open',
        name: 'Huntington Beach Open',
        prize: 10000,
        entryFee: 250,
        maxCompetitors: 64,
        unlockRules: [],
        avgCompetitorRating: 6.8,
        restartIntervalDays: 14
      },
      {
        key: 'wsa_qualifier_malibu',
        name: 'WSA Qualifier - Malibu',
        prize: 25000,
        entryFee: 500,
        maxCompetitors: 64,
        unlockRules: [{ category: 'contest', key: 'huntington_beach_open', value: 'quarterfinals' }],
        avgCompetitorRating: 7.8,
        restartIntervalDays: 30
      },
      {
        key: 'wsa_championship_trestles',
        name: 'WSA Championship - Trestles',
        prize: 50000,
        entryFee: 1000,
        maxCompetitors: 32,
        unlockRules: [{ category: 'contest', key: 'wsa_qualifier_malibu', value: 'semifinals' }],
        avgCompetitorRating: 8.9,
        restartIntervalDays: 60
      }
    ]
  },
  australia_east_coast: {
    name: 'Australia East Coast',
    key: 'australia_east_coast',
    location: 'Australia East Coast',
    surfSpots: ['Byron Bay', 'Snapper Rocks', 'Gold Coast'],
    surfSessionCost: 40,
    surfConsistency: {
      zero: 0.0,
      less_than_10: 0.0,
      from_11_to_30: 0.0,
      from_31_to_60: 0.0,
      from_61_to_120: 0.103,
      from_121_to_180: 0.323,
      from_181_to_270: 0.298,
      from_271_to_365: 0.276
    },
    waveHeight: {
      knee_high: 0.0,
      waist_high: 0.001,
      shoulder_high: 0.304,
      head_high: 0.283,
      overhead: 0.289,
      one_and_half_overhead: 0.122,
      two_overhead: 0.001,
      three_overhead: 0.0,
      big_wave: 0.0
    },
    waveType: {
      crumbling: 0.0,
      easy: 0.411,
      punchy: 0.314,
      hollow: 0.228,
      slab: 0.047
    },
    breakType: {
      beach_break_short: 0.0,
      point_break_medium: 0.0,
      point_break_long: 1.0,
      reef_break_short: 0.0,
      reef_break_medium: 0.0,
      reef_break_long: 0.0
    },
    waveSpeed: {
      slow: 0.397,
      fast: 0.603,
      closeouts: 0.0
    },
    waveTime: {
      less_than_1: 0.0,
      one_to_two: 0.0,
      three_to_five: 0.0,
      six_to_ten: 0.0,
      eleven_to_twenty: 0.482,
      twenty_one_to_forty: 0.518,
      more_than_forty: 0.0
    },
    crowd: {
      uncrowded: 0.122,
      small_crowd: 0.282,
      big_crowd: 0.492,
      packed: 0.104
    },
    crowdSkill: {
      beginners: 0.0,
      intermediates: 0.553,
      advanced: 0.331,
      pros: 0.116
    },
    competitions: [
      {
        key: 'gold_coast_open',
        name: 'Gold Coast Open',
        prize: 12000,
        entryFee: 300,
        maxCompetitors: 64,
        unlockRules: [],
        avgCompetitorRating: 6.9,
        restartIntervalDays: 14
      },
      {
        key: 'wsa_qualifier_snapper_rocks',
        name: 'WSA Qualifier - Snapper Rocks',
        prize: 30000,
        entryFee: 600,
        maxCompetitors: 64,
        unlockRules: [{ category: 'contest', key: 'gold_coast_open', value: 'quarterfinals' }],
        avgCompetitorRating: 7.7,
        restartIntervalDays: 30
      },
      {
        key: 'wsa_championship_gold_coast',
        name: 'WSA Championship - Gold Coast',
        prize: 60000,
        entryFee: 1200,
        maxCompetitors: 32,
        unlockRules: [{ category: 'contest', key: 'wsa_qualifier_snapper_rocks', value: 'semifinals' }],
        avgCompetitorRating: 9.4,
        restartIntervalDays: 60
      }
    ]
  },
  indonesia: {
    name: 'Indonesia',
    key: 'indonesia',
    location: 'Indonesia',
    surfSpots: ['Uluwatu', 'Padang Padang', 'Mentawai Islands'],
    surfSessionCost: 5,
    surfConsistency: {
      zero: 0.0,
      less_than_10: 0.0,
      from_11_to_30: 0.0,
      from_31_to_60: 0.0,
      from_61_to_120: 0.05,
      from_121_to_180: 0.15,
      from_181_to_270: 0.3,
      from_271_to_365: 0.5
    },
    waveHeight: {
      knee_high: 0.0,
      waist_high: 0.0,
      shoulder_high: 0.05,
      head_high: 0.1,
      overhead: 0.3,
      one_and_half_overhead: 0.27,
      two_overhead: 0.2,
      three_overhead: 0.07,
      big_wave: 0.01
    },
    waveType: {
      crumbling: 0.05,
      easy: 0.1,
      punchy: 0.25,
      hollow: 0.4,
      slab: 0.2
    },
    breakType: {
      beach_break_short: 0.1,
      point_break_medium: 0.2,
      point_break_long: 0.1,
      reef_break_short: 0.3,
      reef_break_medium: 0.2,
      reef_break_long: 0.1
    },
    waveSpeed: {
      slow: 0.1,
      fast: 0.7,
      closeouts: 0.2
    },
    waveTime: {
      less_than_1: 0.0,
      one_to_two: 0.05,
      three_to_five: 0.15,
      six_to_ten: 0.3,
      eleven_to_twenty: 0.3,
      twenty_one_to_forty: 0.15,
      more_than_forty: 0.05
    },
    crowd: {
      uncrowded: 0.1,
      small_crowd: 0.2,
      big_crowd: 0.4,
      packed: 0.3
    },
    crowdSkill: {
      beginners: 0.1,
      intermediates: 0.3,
      advanced: 0.4,
      pros: 0.2
    },
    competitions: [
      {
        key: 'uluwatu_open',
        name: 'Uluwatu Open',
        prize: 15000,
        entryFee: 350,
        maxCompetitors: 64,
        unlockRules: [],
        avgCompetitorRating: 7.5,
        restartIntervalDays: 14
      }
    ]
  },
  australia_west_coast: {
    name: 'Australia West Coast',
    key: 'australia_west_coast',
    location: 'Western Australia',
    surfSpots: ['North Point', 'Australian Wave Pool', 'Margaret River'],
    surfSessionCost: 120,
    surfConsistency: {
      zero: 0.0,
      less_than_10: 0.0,
      from_11_to_30: 0.0,
      from_31_to_60: 0.05,
      from_61_to_120: 0.15,
      from_121_to_180: 0.3,
      from_181_to_270: 0.35,
      from_271_to_365: 0.15
    },
    waveHeight: {
      knee_high: 0.0,
      waist_high: 0.0,
      shoulder_high: 0.0,
      head_high: 0.2,
      overhead: 0.2,
      one_and_half_overhead: 0.3,
      two_overhead: 0.17,
      three_overhead: 0.12,
      big_wave: 0.01
    },
    waveType: {
      crumbling: 0.05,
      easy: 0.1,
      punchy: 0.3,
      hollow: 0.4,
      slab: 0.15
    },
    breakType: {
      beach_break_short: 0.1,
      point_break_medium: 0.2,
      point_break_long: 0.2,
      reef_break_short: 0.2,
      reef_break_medium: 0.2,
      reef_break_long: 0.1
    },
    waveSpeed: {
      slow: 0.1,
      fast: 0.7,
      closeouts: 0.2
    },
    waveTime: {
      less_than_1: 0.0,
      one_to_two: 0.05,
      three_to_five: 0.15,
      six_to_ten: 0.3,
      eleven_to_twenty: 0.3,
      twenty_one_to_forty: 0.15,
      more_than_forty: 0.05
    },
    crowd: {
      uncrowded: 0.2,
      small_crowd: 0.3,
      big_crowd: 0.4,
      packed: 0.1
    },
    crowdSkill: {
      beginners: 0.05,
      intermediates: 0.25,
      advanced: 0.5,
      pros: 0.2
    },
    competitions: [
      {
        key: 'north_point_open',
        name: 'North Point Open',
        prize: 20000,
        entryFee: 400,
        maxCompetitors: 64,
        unlockRules: [],
        avgCompetitorRating: 7.8,
        restartIntervalDays: 14
      },
      {
        key: 'wsa_qualifier_margaret_river',
        name: 'WSA Qualifier - Margaret River',
        prize: 40000,
        entryFee: 800,
        maxCompetitors: 64,
        unlockRules: [{ category: 'contest', key: 'north_point_open', value: 'quarterfinals' }],
        avgCompetitorRating: 8.3,
        restartIntervalDays: 30
      },
      {
        key: 'wsa_championship_margaret_river',
        name: 'WSA Championship - Margaret River',
        prize: 80000,
        entryFee: 1600,
        maxCompetitors: 32,
        unlockRules: [{ category: 'contest', key: 'wsa_qualifier_margaret_river', value: 'semifinals' }],
        avgCompetitorRating: 9.2,
        restartIntervalDays: 60
      }
    ]
  },
  hawaii: {
    name: 'Hawaii',
    key: 'hawaii',
    location: 'Oahu, Hawaii',
    surfSpots: ['Pipeline', 'Waimea Bay', 'Honolua Bay'],
    surfSessionCost: 75,
    surfConsistency: {
      zero: 0.0,
      less_than_10: 0.0,
      from_11_to_30: 0.0,
      from_31_to_60: 0.0,
      from_61_to_120: 0.0,
      from_121_to_180: 0.123,
      from_181_to_270: 0.224,
      from_271_to_365: 0.653
    },
    waveHeight: {
      knee_high: 0.0,
      waist_high: 0.0,
      shoulder_high: 0.0,
      head_high: 0.0,
      overhead: 0.312,
      one_and_half_overhead: 0.298,
      two_overhead: 0.198,
      three_overhead: 0.102,
      big_wave: 0.09
    },
    waveType: {
      crumbling: 0.0,
      easy: 0.0,
      punchy: 0.234,
      hollow: 0.679,
      slab: 0.087
    },
    breakType: {
      beach_break_short: 0.0,
      point_break_medium: 0.0,
      point_break_long: 0.0,
      reef_break_short: 0.0,
      reef_break_medium: 1.0,
      reef_break_long: 0.0
    },
    waveSpeed: {
      slow: 0.0,
      fast: 0.781,
      closeouts: 0.219
    },
    waveTime: {
      less_than_1: 0.0,
      one_to_two: 0.0,
      three_to_five: 0.119,
      six_to_ten: 0.201,
      eleven_to_twenty: 0.392,
      twenty_one_to_forty: 0.288,
      more_than_forty: 0.0
    },
    crowd: {
      uncrowded: 0.0,
      small_crowd: 0.0,
      big_crowd: 0.092,
      packed: 0.908
    },
    crowdSkill: {
      beginners: 0.0,
      intermediates: 0.0,
      advanced: 0.314,
      pros: 0.686
    },
    competitions: [
      {
        key: 'honolua_bay_open',
        name: 'Honolua Bay Open',
        prize: 25000,
        entryFee: 500,
        maxCompetitors: 64,
        unlockRules: [],
        avgCompetitorRating: 8.1,
        restartIntervalDays: 14
      },
      {
        key: 'wsa_qualifier_waimea_bay',
        name: 'WSA Qualifier - Waimea Bay',
        prize: 50000,
        entryFee: 1000,
        maxCompetitors: 64,
        unlockRules: [{ category: 'contest', key: 'honolua_bay_open', value: 'quarterfinals' }],
        avgCompetitorRating: 8.9,
        restartIntervalDays: 30
      },
      {
        key: 'wsa_championship_pipeline',
        name: 'WSA Championship - Pipeline',
        prize: 100000,
        entryFee: 2000,
        maxCompetitors: 32,
        unlockRules: [{ category: 'contest', key: 'wsa_qualifier_waimea_bay', value: 'semifinals' }],
        avgCompetitorRating: 9.7,
        restartIntervalDays: 60
      }
    ]
  },
  tahiti: {
    name: 'Tahiti',
    key: 'tahiti',
    location: 'Tahiti, French Polynesia',
    surfSpots: ["Teahupo'o", 'Papara', 'Taapuna'],
    surfSessionCost: 100,
    surfConsistency: {
      zero: 0.0,
      less_than_10: 0.0,
      from_11_to_30: 0.0,
      from_31_to_60: 0.0,
      from_61_to_120: 0.0,
      from_121_to_180: 0.112,
      from_181_to_270: 0.305,
      from_271_to_365: 0.583
    },
    waveHeight: {
      knee_high: 0.0,
      waist_high: 0.0,
      shoulder_high: 0.0,
      head_high: 0.0,
      overhead: 0.0,
      one_and_half_overhead: 0.432,
      two_overhead: 0.283,
      three_overhead: 0.203,
      big_wave: 0.082
    },
    waveType: {
      crumbling: 0.0,
      easy: 0.0,
      punchy: 0.0,
      hollow: 0.332,
      slab: 0.668
    },
    breakType: {
      beach_break_short: 0.0,
      point_break_medium: 0.0,
      point_break_long: 0.0,
      reef_break_short: 1.0,
      reef_break_medium: 0.0,
      reef_break_long: 0.0
    },
    waveSpeed: {
      slow: 0.0,
      fast: 0.879,
      closeouts: 0.121
    },
    waveTime: {
      less_than_1: 0.0,
      one_to_two: 0.0,
      three_to_five: 0.0,
      six_to_ten: 0.203,
      eleven_to_twenty: 0.482,
      twenty_one_to_forty: 0.315,
      more_than_forty: 0.0
    },
    crowd: {
      uncrowded: 0.0,
      small_crowd: 0.112,
      big_crowd: 0.231,
      packed: 0.657
    },
    crowdSkill: {
      beginners: 0.0,
      intermediates: 0.0,
      advanced: 0.224,
      pros: 0.776
    },
    competitions: [
      {
        key: 'teahupoo_olympics',
        name: "Teahupo'o Olympics",
        prize: 30000,
        entryFee: 600,
        maxCompetitors: 64,
        unlockRules: [],
        avgCompetitorRating: 9.9,
        restartIntervalDays: 14
      }
    ]
  }
}

export const COMPETITIONS = Object.values(LOCATIONS).reduce((acc, location) => {
  if (location.competitions) {
    location.competitions.forEach((competition) => {
      acc[competition.key] = competition
    })
  }
  return acc
}, {} as Record<string, Competition>)

export default LOCATIONS
